const devices = {
  moduleTitle: "Devices",
  nav: {
    deviceTypes: "Device Types",
    devices: "Devices",
    sensors: "Sensors",
  },
  actions: {
    view: "View",
    create: "Create",
    update: "Update",
    delete: "Delete",
  },
  permissions: {
    core: "Core",
    deviceManagement: "Device Management",
    deviceTypes: "Device Types",
    devices: "Devices",
    sensors: "Sensors",
  },
  device: {
    form: {
      title: "Assign Device",
      subtitle: "Basic and essential information for the record.",
      generalInfo: "General Information",
      company: "Company",
      companyPlaceholder: "Select company",
      companySearch: "Search companies",
      companyEmpty: "No companies found.",
      deviceType: "Device Type",
      deviceTypePlaceholder: "Select device type",
      deviceTypeSearch: "Search device types",
      deviceTypeEmpty: "No device types found.",
      deviceBrand: "Device Brand",
      deviceBrandPlaceholder: "Select device brand",
      deviceBrandSearch: "Search device brands",
      deviceBrandEmpty: "No device brands found.",
      deviceModel: "Device Model",
      deviceModelPlaceholder: "Select device model",
      deviceModelSearch: "Search device models",
      deviceModelEmpty: "No device models found.",
      imei: "IMEI Number",
      imeiInvalid: "IMEI number must be exactly 15 digits.",
      serialNumber: "Serial Number",
      simNumber: "SIM Number",
      linkedAsset: "Linked Asset",
      linkedAssetPlaceholder: "Select asset",
      linkedAssetSearch: "Search assets",
      linkedAssetEmpty: "No assets found.",
      installationDate: "Installation Date",
      expiryDate: "Expiry Date",
      expiryDatePlaceholder: "Select expiry date",
      expiryDateInvalid: "Expiry date must be after the installation date.",
      notes: "Notes",
      optional: "(optional)",
      nextMonth: "Next month",
      previousMonth: "Previous month",
      createSuccessFallback: "Device created successfully.",
      saveFailed: "The device could not be saved. Please try again.",
      save: "Save",
      cancel: "Cancel",
    },
    list: {
      title: "Device Assignments",
      subtitle: "Manage the devices assigned to your assets.",
      toolbar: {
        search: "Search devices",
        searchPlaceholder: "Search for devices",
        archive: "Archive",
        add: "Assign device",
      },
      table: {
        deviceType: "Product Type",
        company: "Company",
        imei: "IMEI",
        linkedAsset: "Linked Asset",
        status: "Subscription Status",
        expiryDate: "Expiry Date",
        actionMenu: "Actions",
        empty: "No devices found.",
        error: "Failed to load devices.",
        loading: "Loading devices",
        showing: "Showing {{count}} of {{total}}",
        rowsPerPageLabel: "Rows per page",
        nextPage: "Next page",
        previousPage: "Previous page",
        pagination: "Rows per page",
        sortAscending: "Sort ascending",
        sortDescending: "Sort descending",
      },
      status: {
        active: "Active",
        inactive: "Inactive",
      },
      filters: {
        filters: "Filters",
        deviceCode: "Device ID",
        deviceCodePlaceholder: "DEV-000001",
        deviceType: "Device Type",
        deviceTypePlaceholder: "Select device type",
        deviceTypeSearch: "Search device types",
        deviceTypeEmpty: "No device types found.",
        company: "Company",
        companyPlaceholder: "Select company",
        companySearch: "Search companies",
        companyEmpty: "No companies found.",
        imei: "IMEI Number",
        imeiPlaceholder: "356938035643809",
        linkedAsset: "Linked Asset",
        linkedAssetPlaceholder: "Select asset",
        linkedAssetSearch: "Search assets",
        linkedAssetEmpty: "No assets found.",
        status: "Status",
        allStatuses: "All statuses",
        expiryDate: "Expiry Date",
        expiryDatePlaceholder: "Select a date range",
        clearDateRange: "Clear",
        nextMonth: "Next month",
        previousMonth: "Previous month",
        apply: "Apply",
        reset: "Reset",
      },
      actions: {
        view: "View",
        update: "Update",
        delete: "Delete",
        extend: "Extend",
        activate: "Activate",
        deactivate: "Deactivate",
        notAvailableYet: "This action isn't available yet.",
      },
    },
    deleteDialog: {
      title: "Delete",
      question: "Are you sure you want to delete this device?",
      warning: "This action is permanent and cannot be undone.",
      confirmWord: "DELETE",
      instruction: 'Type "{{word}}" to confirm deletion',
      inputLabel: "Deletion confirmation",
      cancel: "Cancel",
      confirm: "Delete",
      close: "Close delete dialog",
      successFallback: "Device deleted successfully.",
      errorFallback: "Failed to delete device. Please try again.",
    },
    detail: {
      backToList: "Back to devices",
      edit: "Edit",
      extend: "Extend",
      generalInfo: "General Information",
      company: "Company",
      deviceType: "Device Type",
      deviceModel: "Device Model",
      imei: "IMEI Number",
      serialNumber: "Serial Number",
      deviceBrand: "Manufacturer",
      simNumber: "SIM Number",
      linkedAsset: "Linked Asset",
      installationDate: "Installation Date",
      expiryDate: "Expiry Date",
      notes: "Notes",
      notAvailable: "Not available",
      tabs: {
        upcoming: "Upcoming",
        current: "Current",
        previous: "Previous",
      },
      tabContentNotAvailable: "Not available yet.",
      loading: "Loading device",
      loadError: "Failed to load this device.",
      empty: "Device not found.",
    },
    edit: {
      title: "Edit Device",
      subtitle: "Update the linked asset or notes for this device.",
      updateSuccessFallback: "Device updated successfully.",
      updateFailed: "The device could not be updated. Please try again.",
    },
    archivedDevices: {
      title: "Archived Devices",
      subtitle: "Devices that have been archived and can be restored.",
      toolbar: {
        search: "Search archived devices",
      },
      table: {
        company: "Company",
        imei: "IMEI",
        brandModel: "Brand & Model",
        linkedAsset: "Linked Asset",
        archivedAt: "Archive Date",
        actionMenu: "Actions",
        empty: "No archived devices found.",
        error: "Failed to load archived devices.",
        loading: "Loading archived devices",
        showing: "Showing {{count}} of {{total}}",
        rowsPerPageLabel: "Rows per page",
        nextPage: "Next page",
        previousPage: "Previous page",
        pagination: "Rows per page",
        sortAscending: "Sort ascending",
        sortDescending: "Sort descending",
      },
      filters: {
        archivedAt: "Archive Date",
        archivedAtPlaceholder: "Select a date range",
        clearDateRange: "Clear",
        nextMonth: "Next month",
        previousMonth: "Previous month",
      },
      actions: {
        restore: "Restore device",
      },
    },
    restoreDialog: {
      title: "Restore Device",
      question: "A device with the same details already exists in the archive",
      prompt: "Do you want to restore this device?",
      cancel: "Cancel",
      confirm: "Restore Device",
      close: "Close restore dialog",
      successFallback: "Device restored successfully.",
    },
    restoreArchivedDeviceDialog: {
      title: "Restore Device",
      question: "Are you sure you want to restore this device?",
      prompt:
        "The device will become active again and can be used in the system.",
      cancel: "Cancel",
      confirm: "Restore Device",
      close: "Close restore dialog",
      successFallback: "Device restored successfully.",
      errorFallback: "The device could not be restored.",
    },
    capacity: {
      label: "Devices capacity",
      total: "Total devices",
      used: "Used devices",
      remaining: "Remaining devices",
    },
    noCapacityDialog: {
      title: {
        createDevice: "Module Subscription Required",
        restoreDevice: "Module Subscription Required",
        activateDevice: "Device Subscription Required",
      },
      message: {
        createDevice:
          "This Device cannot be created because no valid current or future Device subscription covers it. Please extend the subscription first.",
        restoreDevice:
          "This Device cannot be restored because no valid current or future Device subscription covers it. Please extend the subscription first.",
        activateDevice:
          "This Device cannot be activated because no valid current or future Device subscription covers it. Please extend the subscription first.",
      },
      ok: "OK",
      close: "Close the subscription required notice",
    },
    activateDialog: {
      title: "Activate Device",
      description: "Pick the last day of the device's subscription term.",
      imei: "IMEI",
      startDate: "Start Date",
      endDate: "End Date",
      endDatePlaceholder: "Select end date",
      endDateRequired: "End Date is required.",
      endDateAfterStart: "End Date must be later than Start Date.",
      activate: "Activate",
      cancel: "Cancel",
      close: "Close the activation form",
    },
    subscriptionRequiredDialog: {
      title: "Device Subscription Required",
      message:
        "This Device cannot be activated because no valid current or future Device subscription covers the selected period. Please extend the devices subscription first.",
      ok: "OK",
      close: "Close the subscription required notice",
    },
    statusDialog: {
      titleActivate: "Activate Device",
      titleDeactivate: "Deactivate Device",
      questionActivate: "Are you sure you want to activate this device?",
      questionDeactivate: "Are you sure you want to deactivate this device?",
      imei: "IMEI: {{imei}}",
      noteDeactivate: "It will become inactive.",
      confirmActivate: "Confirm Activation",
      confirmDeactivate: "Confirm Deactivation",
      cancel: "Cancel",
      close: "Close status change dialog",
      activatedFallback: "Device activated successfully.",
      deactivatedFallback: "Device deactivated successfully.",
      statusChanged:
        "The device status has changed. Please refresh and try again.",
      activateFailed: "Unable to activate the device. Please try again.",
      deactivateFailed: "Unable to deactivate the device. Please try again.",
    },
  },
};

export default devices;
